import { LazyExoticComponent, Suspense, lazy } from 'react';

import * as St from './ShapeItem.styles';

import { PredefinedShape } from '~/core/models';

type imgIdToSvgImportType = {
  [key: number]: LazyExoticComponent<
    React.ComponentType<React.SVGProps<SVGSVGElement>>
  >;
};

const imgIdToSvgImport: imgIdToSvgImportType = {
  1: lazy(() => import('/public/assets/images/Layouts/Rectangle.svg')),
  2: lazy(() => import('/public/assets/images/Layouts/LShape.svg')),
  3: lazy(() => import('/public/assets/images/Layouts/UShape.svg')),
  4: lazy(() => import('/public/assets/images/Layouts/Gallery.svg')),
  5: lazy(() => import('/public/assets/images/Layouts/TwoSideBatwing.svg')),
  6: lazy(() => import('/public/assets/images/Layouts/ThreeSideBatwing.svg')),
  7: lazy(() => import('/public/assets/images/Layouts/GShape.svg')),
  8: lazy(() => import('/public/assets/images/Layouts/LShapeIsland.svg')),
  9: lazy(() => import('/public/assets/images/Layouts/UShapeIsland.svg')),
  10: lazy(() => import('/public/assets/images/Layouts/LShapeDiagonal.svg')),
  11: lazy(() => import('/public/assets/images/Layouts/UShapeDiagonal.svg')),
};

type ShapeItemProps = {
  shape: PredefinedShape;
  isSelected?: boolean;
  onSelect: () => void;
  className?: string;
};

const ShapeItem = ({
  shape,
  isSelected = false,
  onSelect,
  className,
}: ShapeItemProps) => {
  const ShapeIcon = imgIdToSvgImport[shape.id];

  return (
    <St.Container onClick={onSelect} className={className}>
      <St.ShapeImage
        data-is-selected={isSelected}
        component={() => (
          <Suspense fallback={null}>
            <ShapeIcon />
          </Suspense>
        )}
      />
      <St.ShapeTitle>{shape.title}</St.ShapeTitle>
    </St.Container>
  );
};

export default ShapeItem;
